import { CplaceSingleNumberControlChange, CplaceSingleNumberControlParameters } from '../../api/model/models';
import { ControlChangeHandler } from '../../controls';
import { mockControlIdentity, mockControlStateSharedData } from './controls.shared';

export const mockCplaceSingleNumberControlControlParams: CplaceSingleNumberControlParameters = {
  componentName: 'CplaceSingleNumberControlComponent',
  value: 300,
  fractionalDigits: 0,
};

export const mockCplaceSingleNumberControlControlState = {
  ...mockControlStateSharedData,
  identity: mockControlIdentity,
  controlParameters: mockCplaceSingleNumberControlControlParams,
};

export const mockCplaceSingleNumberControlChangeHandler: ControlChangeHandler<
  CplaceSingleNumberControlChange,
  CplaceSingleNumberControlParameters
> = (controlParameters, controlChange) => {
  return {
    ...controlParameters,
    value: controlChange.value,
  };
};
